module.exports = __webpack_public_path__ + "img/head.9ef08a3b.png";